import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import StoresListComponent from "./views/StoresList";
const StoresList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <StoresListComponent params={params} />;
};

// This is Store Details OMI Reports
const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Store Details",
          description: "store details report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<StoresList />} />
      </Routes>
    </>
  );
};

export default Component;
